export default {
  bindings: {
    manager: '<',
    course: '<',
  },
  controller: function ctrl(
    CurrentUserManager,
  ) {
'ngInject';
    const vm = this;
    vm.CurrentUserManager = CurrentUserManager;
    return vm;
  },
  controllerAs: 'vm',
  templateUrl: 'timelines/templates/nv-new-timeline-todos.html',
};
